import { useState } from "react";
import {
  Box,
  Button,
  HStack,
  IconButton,
  Image,
  Input,
  Text,
  VStack,
  useDisclosure,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
} from "@chakra-ui/react";
import upArrowIcon from "../../../assets/waveflowmain/upArrowIcon.png";
import arrowDownBtn from "../../../assets/sidenavbar/arrowDownBtn.png";
import PopoverMenu from "./PopoverMenu";
import copyIcon from "../../../assets/waveflowmain/copyIcon.png";
import { useRef } from "react";

const DynamicInputBlocks = ({
  blocks,
  setBlocks,
  title,
  formData,
  setFormData,
  errorset,
}) => {
  const [savedData, setSavedData] = useState([]);
  const [handleDrop, setHandleDrop] = useState(false);
  const [textCopy, settextCopy] = useState("");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = useRef();

  const addBlock = () => {
    setBlocks([...blocks, ""]);
  };

  const handleInputChange = (index, value) => {
    settextCopy(value);
    const newBlocks = [...blocks];
    newBlocks[index] = value;
    setBlocks(newBlocks);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(textCopy);
  };

  const handleDelete = (index) => {
    blocks.slice(index, 1);
    const newData = [...blocks];
    const data = newData.filter((ele, i) => i != index);
    setBlocks(data);
  };

  const handleClear = () => {
    setBlocks([]);
    onClose();
  };

  return (
    <>
      <VStack align="start" spacing={1} p={2} borderWidth={1} borderRadius="md">
        <HStack w="full" justify="space-between">
          <HStack>
            <IconButton
              bg="transparent"
              onClick={() => setHandleDrop(!handleDrop)}
              size="xs"
              icon={
                <Image
                  src={handleDrop ? upArrowIcon : arrowDownBtn}
                  width="16px"
                />
              }
            />
            <Box fontSize="small" fontWeight="bold">
              {title}
            </Box>
          </HStack>
       
        </HStack>

        {handleDrop && (
          <>
            {blocks &&
              blocks.map((block, index) => (
                <Box key={index} w="full" borderRadius="md">
                  <HStack justifyContent="space-between">
                    <Box></Box>
                    <HStack gap={0}>
                      <IconButton
                        bg="transparent"
                        onClick={handleCopy}
                        size="xs"
                        icon={<Image src={copyIcon} width="14px" />}
                      />
                      <PopoverMenu handleDelete={() => handleDelete(index)} />
                    </HStack>
                  </HStack>
                  <Input
                    size="md"
                    placeholder="Prompt text..."
                    value={block}
                    border="1px solid lightgray"
                    onChange={(e) => handleInputChange(index, e.target.value)}
                  />
                </Box>
              ))}
            <Button size="xs" onClick={addBlock} colorScheme="white">
              ➕
            </Button>
          </>
        )}
        {errorset?.userError && (
          <Text ml="20px" fontSize="12px" color="red">
            {errorset?.userError}
          </Text>
        )}
      </VStack>

    </>
  );
};

export default DynamicInputBlocks;
